const config = {
  baseUrl: "https://api.corpquick.com",
  pdfUrl: "https://admin.corpquick.com/documents",
  imgURL: "https://admin.corpquick.com",
//   baseUrl: 'http://127.0.0.1:9900',
//   pdfUrl: 'http://127.0.0.1:9900/documents',
//   imgURL:'http://127.0.0.1:8800', // base url of admin api
};

export default config;
